import template from './contactCreditScoreBox.template.html';
import { ContactCreditScoreType } from '__core/shared/model/contact/ContactCreditScoreType.enum';

export default {
  template,
  bindings: {
    idTicket: '<',
    owner: '<',
    contact: '=',
    loanAmount: '<',
    isEquifaxEnabled: '<',
    isIllionEnabled: '<',
    isDisabled: '<'
  },
  controllerAs: '$ctrl',
  controller: class controller {
    constructor() {
      'ngInject';

      const ctrl = this;
      ctrl.showEquifax = false;
      ctrl.showIllion = false;
      ctrl.creditScoreObject = {};
      ctrl.creditScoreObjectEquifax = {};
      ctrl.creditScoreObjectIllion = {};
      ctrl.creditScore = 'N/A';
      ctrl.creditColor = 'grey-600';

      ctrl.initialize = () => {
        const creditScores = _.orderBy(ctrl.contact?.creditScore, 'timeStamp', 'desc');
        ctrl.creditScoreObject = _.head(creditScores) || {};
        ctrl.creditScoreObjectEquifax =
          _.head(
            _.filter(
              creditScores,
              (cs) =>
                cs.type === 'equifax' || cs.type.name === ContactCreditScoreType.equifax.name
            )
          ) || {};
        ctrl.creditScoreObjectIllion =
          _.head(
            _.filter(
              creditScores,
              (cs) =>
                cs.type === 'illion' || cs.type.name === ContactCreditScoreType.illion.name
            )
          ) || {};
        const score = parseInt(ctrl.creditScoreObject?.score, 10);
        ctrl.creditScore = Number.isNaN(score) ? 'N/A' : score;
        ctrl.creditColor = 'grey-600';
        if (ctrl.creditScore < 200) {
          ctrl.creditColor = 'red-600';
        }
        if (ctrl.creditScore < 600) {
          ctrl.creditColor = 'amber-600';
        }
        if (ctrl.creditScore > 600) {
          ctrl.creditColor = 'green-600';
        }
      };

      ctrl.onFinished = (idContact, creditScore) => {
        ctrl.showEquifax = false;
        ctrl.showIllion = false;
        if (idContact && creditScore && creditScore.length) {
          ctrl.contact.creditScore = creditScore;
          ctrl.initialize();
        }
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
